import React, { FC } from "react";
import { CalendarPeriod } from "../calendarPeriod";

interface PeriodOption {
  value: CalendarPeriod;
  label: string;
}

interface PeriodToggleProps {
  currentPeriod: CalendarPeriod;
  options: PeriodOption[];
  onChange: (period: CalendarPeriod) => void;
}

export const PeriodToggle: FC<PeriodToggleProps> = ({
  currentPeriod,
  options,
  onChange,
}) => (
  <div className="flex rounded-md overflow-hidden border border-slate-300 ml-auto">
    {options.map((option) => (
      <button
        type="button"
        key={option.value}
        onClick={() => onChange(option.value)}
        className={`px-3 py-1 text-sm font-medium transition-colors ${
          currentPeriod === option.value
            ? "bg-[#3788d8] text-white"
            : "bg-white text-slate-700 hover:bg-slate-100"
        }`}
      >
        {option.label}
      </button>
    ))}
  </div>
);
